import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import PaperPlane from 'components/Icons/PaperPlane';
import { styled } from '@mui/material/styles';

const StyledPaperPlan = styled(PaperPlane)({
  display: 'block',
  textAlign: 'center',
  margin: '9px 0 3px',
});

const FormSent = ({ ticketNumber }) => (
  <>
    <StyledPaperPlan />
    <Typography variant="h1" align="center" mb={4}>
      Thank you for contacting The Bash!
    </Typography>
    <Typography variant="body1" mb={4}>
      We have received your inquiry and have assigned it a ticket number: #{ticketNumber}.
    </Typography>
    <Typography variant="body1">
      If you have emailed us to receive price quotes or contact information for a vendor you see on
      The Bash, please contact the vendor directly by clicking the request free quote button on
      their profile.
    </Typography>
  </>
);

FormSent.propTypes = {
  ticketNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default FormSent;
